<template>
  <div>
    <div class="modal-backdrop" @click="close"></div>
    <div class="modal">
      <div v-if="!isLoading">
        <bg-field
          class="search-input"
          :key="background.element"
          :label="`Input for ${background.element}`"
          name="search"
        >
          <bg-input
            name="search"
            placeholder="Search for study"
            v-model="input"
            :rows="3"
            height="50px"
          />
        </bg-field>
        <div style="display: flex; justify-content: center; gap: 10px">
          <bg-button variant="secondary" text="Cancel" @click="close" />
          <bg-button
            variant="primary"
            class="action"
            text="Send"
            @click="send"
          />
        </div>
      </div>
      <div v-else>
        <p>LOADING...</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal {
  background: #efefef;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  padding: 40px 80px;
  border-radius: var(--bg-border-radius);
  min-width: 600px;
  z-index: 101;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}

.header {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
}

.modal-footer {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.modal-body {
  margin-bottom: 40px;
}
</style>

<script>
import BgInput from "@/components/bg-input";
import BgField from "@/components/bg-field";
import BgButton from "@/components/bg-button";
import API from "@/api";

export default {
  name: "BgModal",
  props: ["background"],
  components: {
    BgField,
    BgInput,
    BgButton,
  },
  data() {
    return {
      input: "",
      isLoading: false,
    };
  },
  methods: {
    async send() {
      this.isLoading = true;

      const res = await API.openAi.anything({
        max_tokens: 2000,
        prompt: this.input,
        text: this.background.text,
      });
      this.isLoading = false;
      this.$emit("result", res);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
